import { render } from "./ScreenBase.vue?vue&type=template&id=29b2484e"
import script from "./ScreenBase.vue?vue&type=script&lang=js"
export * from "./ScreenBase.vue?vue&type=script&lang=js"

import "./ScreenBase.vue?vue&type=style&index=0&id=29b2484e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__